import { Component, computed, input } from '@angular/core';
import { TuiSizeL, TuiSizeS } from '@taiga-ui/core';
import { TuiAvatar, TuiAvatarOutline } from '@taiga-ui/kit';

export type PlaceholderConfig = {
	header: string;
	content: string;
	icon: string;
};

const IconSizeMap = {
	m: 'l',
	l: 'xl',
};

const TextSizeMap = {
	m: { header: 'font-size-small', content: 'font-size-medium' },
	l: { header: 'font-size-medium', content: 'font-size-large' },
};
@Component({
	imports: [TuiAvatar, TuiAvatarOutline],
	selector: 'ctx-table-placeholder',
	templateUrl: 'table-placeholder.component.html',
	styleUrl: 'table-placeholder.component.scss',
	host: {
		'[attr.size]': 'size()',
	},
})
export class TablePlaceholderComponent {
	readonly size = input<TuiSizeL>('l');

	readonly header = input.required<string>();

	readonly content = input.required<string>();

	readonly icon = input.required<string>();

	readonly iconSize = computed(() => IconSizeMap[this.size()] as TuiSizeL);
	readonly headerSize = computed(() => TextSizeMap[this.size()].header);
	readonly contentSize = computed(() => TextSizeMap[this.size()].content);
}
